import { useQuery } from '@tanstack/react-query';
import {
  type Calendar_EventTagFilter,
  type QueryAdditionalOptions,
  type UseQueryReturnType,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { calendarKeys } from '../keys';

const calendarEventTags = graphql(/* GraphQL */ `
  query calendar_eventTags($filter: Calendar_EventTagFilter) {
    calendar_eventTags(filter: $filter) {
      id
      type
      systemTag
      name
      description
      colour
      refId
      icon
    }
  }
`);

const calendarEventTagsQuery = (filter: Calendar_EventTagFilter) => ({
  queryKey: calendarKeys.tags(filter),
  queryFn: async () =>
    gqlClient.request(calendarEventTags, {
      filter,
    }),
});

export function getCalendarEventTags(filter: Calendar_EventTagFilter) {
  return queryClient.fetchQuery(calendarEventTagsQuery(filter));
}

export function useCalendarEventTags(
  filter: Calendar_EventTagFilter,
  additionalOptions?: Omit<QueryAdditionalOptions, 'academicNamespaceId'>,
) {
  return useQuery({
    ...calendarEventTagsQuery(filter),
    ...additionalOptions,
    select: ({ calendar_eventTags }) => calendar_eventTags ?? [],
  });
}

export type ReturnTypeFromUseCalendarEventTags = UseQueryReturnType<
  typeof useCalendarEventTags
>[number];
